/**
* @Description 文件功能说明：角色组件
* @Author
* @Time 2021/6/4
**/

/* HTML */
<template>
    <div :class="{'tree-item-box': true, 'mini-box': !showBoxFlag}">

<!--        <div class="box-bar-item" @click="toggleBox" title="展开/收起 组织结构">
            <i v-if="showBoxFlag" class="iconfont el-icon-my_left2-copy"></i>
            <i v-else class="iconfont el-icon-my_right2"></i>
        </div>-->

        <div class="tree-group-title">
            <span class="tree-group-name">项目结构</span>
        </div>

        <div class="tree-group-item">
            <el-tree
                :props="defaultProps"
                :data="organizations"
                node-key="id"
                :default-expand-all="true"
                :expand-on-click-node="false"
                @node-click="handleTreeNode"
            >
                <template v-slot="{node, data}">
                    <span class="custom-tree-node">
                        <span>{{data.label}}</span>
                    </span>
                </template>
            </el-tree>
        </div>

    </div>

</template>

/* JS */
<script>

export default {
	/**
     * @Des 组件名
     * @Auth
     * @Date 2022/1/20
     */
    name: 'OrgTree',

    /**
     * @Des 数据接收类型
     * @Auth
     * @Date 2021/6/4
     */
    props: {
        /**
         * @Des 展示box
         * @Auth
         * @Date 2021/6/5
         */
        showBoxFlag: {
            type: Boolean,
            default: function (){
                return true
            }
        },
        organizations:{
            type: Array,
            default: function (){
                return [];
            }
        }

    },

    /**
     * @Des 组件引用
     * @Auth
     * @Date 2021/6/4
     */
    components: {
        // 角色弹窗
    },

    /**
     * @Des 数据定义
     * @Auth
     * @Date 2021/6/4
     */
    data() {
        return {

            /**
             * @Des 树属性默认定义
             * @Auth
             * @Date 2021/6/4
             */
            defaultProps: {
                label: 'name',
                children: 'children'
            },
            // 操作锁
            operationLock: false,
        }
    },

    /**
     * @Des 方法定义
     * @Auth
     * @Date 2021/6/4
     */
    methods: {
        /**
         * @Des mini max box
         * @Auth
         * @Date 2021/6/5
         */
        toggleBox() {
            this.$emit('toggleBox', !this.showBoxFlag);
        },
        /**
         * @Des 处理树节点
         * @Auth
         * @Date 2021/6/4
         */
        handleTreeNode(data){
            this.$emit('setSelectVal', data);
            this.$emit('closeSecondModule', data);
        },


        /**
         * 添加
         */
        add(){
            this.$emit('addNode');
        },
    },

    /**
     * @Des 初始化加载
     * @Auth
     * @Date 2021/6/4
     */
    created() {

    },


}
</script>

/* CSS */
<style lang="scss" scoped>

</style>




// WEBPACK FOOTER //
// src/components_pages/Organization/OrgTree.vue